import React, { Children } from "react";
import { ReactComponent as CheckedCircle } from "@zendeskgarden/svg-icons/src/16/check-circle-stroke.svg";

export default function Tips({ color = "#038153", children }) {
  return (
    <>
      <div className="flex gap-2 items-center" style={{ color: color }}>
        <span>
          <CheckedCircle />
        </span>

        {children}
      </div>
    </>
  );
}
